import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";
import FilmCard from "@/components/FilmCard";
import SubGenreChips from "@/components/SubGenreChips";
import useGenres from "@/hooks/useGenres";

// Homepage "AI Films" row; hidden until at least one AI Film is listed.
export default function AiFilmsRow() {
  const { ai_film: aiFilm } = useGenres();
  const [films, setFilms] = useState([]);
  const [sub, setSub] = useState(null);

  useEffect(() => {
    api.get("/films", { params: { genre: aiFilm } }).then((r) => setFilms(r.data || [])).catch(() => setFilms([]));
  }, [aiFilm]);

  const shown = useMemo(() => (sub ? films.filter((f) => f.sub_genre === sub) : films), [films, sub]);
  if (films.length === 0) return null;

  return (
    <section className="px-6 sm:px-12 lg:px-20 pt-16 max-w-[1600px] mx-auto" data-testid="ai-films-section">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-5">
        <div>
          <p className="text-xs uppercase tracking-widest text-sky-300 font-semibold mb-2 flex items-center gap-1.5">
            <Sparkles className="w-3 h-3" /> New frontier
          </p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold leading-tight">AI Films</h2>
        </div>
        <Link to={`/browse?genre=${encodeURIComponent(aiFilm)}`} className="text-sm text-gold hover:underline" data-testid="ai-films-see-all">See all →</Link>
      </div>
      <div className="mb-6"><SubGenreChips value={sub} onChange={setSub} testPrefix="home-subgenre" /></div>
      {shown.length === 0 ? (
        <p className="text-sm text-foreground/50 py-8" data-testid="ai-films-empty">No {sub} films yet — check back soon.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4" data-testid="ai-films-grid">
          {shown.slice(0, 10).map((f, i) => <FilmCard key={f.id} film={f} index={i} fluid />)}
        </div>
      )}
    </section>
  );
}
